var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99803 9.65555C4.09921 8.93444 3.16699 8.18889 3.16699 7.02778C3.16699 5.69556 4.45678 4.76667 6.61493 4.76667C8.88801 4.76667 9.73084 5.80556 9.80746 7.33333H12.6297C12.5403 5.23111 11.1994 3.3 8.53045 2.67667V0H4.69941V2.64C2.222 3.15333 0.229862 4.69333 0.229862 7.05222C0.229862 9.87556 2.66896 11.2811 6.23183 12.1C9.42436 12.8333 10.0629 13.9089 10.0629 15.0456C10.0629 15.8889 9.43713 17.2333 6.61493 17.2333C3.98428 17.2333 2.9499 16.1089 2.80943 14.6667H0C0.153242 17.3433 2.24754 18.8467 4.69941 19.3478V22H8.53045V19.3722C11.0206 18.92 13 17.5389 13 15.0333C13 11.5622 9.89686 10.3767 6.99803 9.65555Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.e36d9a30a98b6c5c46d04823f2c7a6e3.svg";
export { ForwardRef as ReactComponent };